module.exports = __webpack_public_path__ + "img/5.97569ea5.png";